import React, { useState, useEffect } from 'react';
import './App.css';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { NavigationBar } from './components/NavigationComponents/NavigationBar/NavigationBar';
import {Reports} from './Reports/Reports';
import CustomizedTables from './Reports/PeriodicReports';
import CloseReports from './Reports/CloseReports';
import StationMap from './Reports/StationMap';
import Sidebar from './components/NavigationComponents/Sidebar/Sidebar';
import { TankArrayCreator } from './Reports/ATG';
import Stations from './Reports/Stations';
import Footer from './components/NavigationComponents/Footer/Footer';
import { canSeePage } from './components/roleAccess';
import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css';
import './fontawesome-woff2.css';
import Login from './components/Login/Login';
import useToken from './components/App/useToken';
import NotAuthorized from './components/NavigationComponents/NotAuthorized/NotAuthorized';
import OffloadingReports from './Reports/OffloadingReports';
import Cards from './Reports/Cards';
import Users from './Reports/Users';
import AttendantCards from './Reports/Attendantcards'; // Updated to lowercase 'c' to fix compiler error
import Statistics from './Reports/Statistics';
import Orders from './Reports/Orders';
import BusesReports from './Reports/buses_reports';
import { API_BASE } from './config';
import InstallAppPrompt from './InstallAppPrompt';
import { tr } from './i18n';

function App() {

  const [showFilterFields, setShowFilterFields] = useState("none");
  const [showReportsCheckboxes, setShowReportsCheckboxes] = useState("none");
  const { token, setToken } = useToken();
  // true = navigation menu hidden. Saved in the browser so it survives a
  // refresh or a language switch.
  const [viewMenusState, setViewMenusState] = useState(() => {
    try { return window.localStorage.getItem('app_nav_hidden') === '1'; } catch (e) { return false; }
  });
  useEffect(() => {
    try { window.localStorage.setItem('app_nav_hidden', viewMenusState ? '1' : '0'); } catch (e) { /* ignore */ }
  }, [viewMenusState]);


/*sessionStorage.setItem('saved', new Date().getTime());

const LogoutTimeout = () => {
let hours = 0.5
if(token) {
let saved = sessionStorage.getItem('saved')
if (saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) {
  alert("Session Expired");
  sessionStorage.clear();
  window.location.reload(false);
}
}}
window.location.hostname}:4000
setInterval(LogoutTimeout, 1000);*/

  //Timeout check begin.
const LogoutTimeout = () => {
    fetch(`${API_BASE}/auth/refresh`, {
      headers: { Authorization: token.refresh_token },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Response not OK.", response);
      }
      return response.json();
    })
      .then((data) => {
        if (data.data === null) {
          alert(tr("Session Timed Out"));
          sessionStorage.clear();
          window.location.reload(false);
        } else {
          setToken(data);
        }
      })
      .catch((e) => {
        alert(tr("Could not connect to server..."));
        sessionStorage.clear();
        window.location.reload(false);
      });
};
  //Timeout check end.

  const setShowFilterState = () => {
    if (showFilterFields === "none")
    setShowFilterFields("block")
    if (showFilterFields === "block")
      setShowFilterFields("none")
  }

  const setReportsCheckboxesState = () => {
    if (showReportsCheckboxes === "none")
    setShowReportsCheckboxes("block")
    if (showReportsCheckboxes === "block")
    setShowReportsCheckboxes("none")
  }

  // Card-manager identity is distinguished by email only — server-side both
  // card@manager.com and ak4tek@admin.com carry roles.id: 1 (SuperAdmin), so
  // role-based gating can't separate them. Match the same constant Cards.js uses.
  const CARD_MANAGER_EMAIL = 'card@manager.com';
  const isCardManager = token?.user_record?.email === CARD_MANAGER_EMAIL;

  if(!token) {
    return(
    <>
    <Login setToken={setToken} />
    <Router>
    <Footer token={token} setViewMenusState={setViewMenusState} viewMenusState={viewMenusState}/>
    </Router>
    <InstallAppPrompt />
    </>)
  }

  // Card-manager: Allowed access to BOTH Cards and AttendantCards.
  // Everything else falls through to NotAuthorized.
  else if (isCardManager) {
    return (
      <React.Fragment>
        <Router>
          <NavigationBar viewMenusState={viewMenusState} LogoutTimeout={LogoutTimeout} showFilterFields={showFilterFields} setShowFilterState={setShowFilterState} showReportsCheckboxes={showReportsCheckboxes} setReportsCheckboxesState={setReportsCheckboxesState}/>
          <Switch>
            <Route exact path={["/", "/Cards"]}>
              <Sidebar pageType="CardsSidebar" token={token} LogoutTimeout={LogoutTimeout}/>
              <Cards token={token} LogoutTimeout={LogoutTimeout} />
            </Route>
            <Route path="/AttendantCards">
              <Sidebar pageType="CardsSidebar" token={token} LogoutTimeout={LogoutTimeout}/>
              <AttendantCards token={token} LogoutTimeout={LogoutTimeout} />
            </Route>
            <Route>
              <NotAuthorized token={token} LogoutTimeout={LogoutTimeout}/>
            </Route>
          </Switch>
          <Footer token={token} setViewMenusState={setViewMenusState} viewMenusState={viewMenusState}/>
        </Router>
        <InstallAppPrompt />
      </React.Fragment>
    );
  }

  // Any logged-in, non-card-manager user. Page access is driven entirely by the
  // central map in components/roleAccess.js.
  else if (token && token.user_record) {

  return (
    <React.Fragment>
  <Router>
  <NavigationBar viewMenusState={viewMenusState} LogoutTimeout={LogoutTimeout} showFilterFields={showFilterFields} setShowFilterState={setShowFilterState} showReportsCheckboxes={showReportsCheckboxes} setReportsCheckboxesState={setReportsCheckboxesState}/>
    <Switch>
  {canSeePage(token, 'Statistics') && (
  <Route path="/Statistics">
  <Statistics token={token} LogoutTimeout={LogoutTimeout}/>
  </Route>
  )}

  {canSeePage(token, 'StationMap') && (
  <Route path="/StationMap">
  <StationMap token={token} LogoutTimeout={LogoutTimeout}/>
  </Route>
  )}

  {canSeePage(token, 'Reports') && (
  <Route exact path={["/", "/Reports"]}>
  <Sidebar pageType="ReportsSidebar" showFields={setShowFilterState} showCheckboxes={setReportsCheckboxesState} token = {token} LogoutTimeout={LogoutTimeout}/>
  <Reports toggleButton={showFilterFields} checkboxesView={showReportsCheckboxes} token = {token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {canSeePage(token, 'PeriodicReports') && (
  <Route path="/PeriodicReports">
  <Sidebar pageType="PeriodicReportsSidebar" showFields={setShowFilterState} showCheckboxes={setReportsCheckboxesState} token = {token} LogoutTimeout={LogoutTimeout}/>
  <CustomizedTables toggleButton={showFilterFields} checkboxesView={showReportsCheckboxes} token = {token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {canSeePage(token, 'CloseReports') && (
  <Route path="/CloseReports">
  <Sidebar pageType="CloseReportsSidebar" token = {token} LogoutTimeout={LogoutTimeout}/>
  <CloseReports token = {token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {canSeePage(token, 'OffloadingReports') && (
  <Route path="/OffloadingReports">
  <Sidebar pageType="CloseReportsSidebar" token = {token} LogoutTimeout={LogoutTimeout}/>
  <OffloadingReports token = {token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {canSeePage(token, 'TankGauge') && (
  <Route path="/TankGauge">
    <Sidebar pageType="TankSidebar" token = {token} LogoutTimeout={LogoutTimeout}/>
    <TankArrayCreator token = {token} LogoutTimeout={LogoutTimeout}/>
    </Route>
  )}

  {canSeePage(token, 'Stations') && (
  <Route path={["/Stations", "/Settings"]}>
   <Stations token={token} LogoutTimeout={LogoutTimeout}/>
    </Route>
  )}

  {/* User management — create-only, restricted to roles that may create users */}
  {canSeePage(token, 'Users') && (
  <Route path="/Users">
    <Users token = {token} LogoutTimeout={LogoutTimeout}/>
    </Route>
  )}

  {canSeePage(token, 'Cards') && (
  <Route path="/Cards">
    <Cards token={token} LogoutTimeout={LogoutTimeout}/>
    </Route>
  )}

  {/* Regular user path for AttendantCards (using same permissions framework) */}
  {canSeePage(token, 'AttendantCards') && (
  <Route path="/AttendantCards">
    <AttendantCards token={token} LogoutTimeout={LogoutTimeout}/>
    </Route>
  )}

  {canSeePage(token, 'Orders') && (
  <Route path="/Orders">
    <Orders token={token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {canSeePage(token, 'BusesReports') && (
  <Route path="/BusesReports">
    <BusesReports token = {token} LogoutTimeout={LogoutTimeout} />
  </Route>
  )}

  {/* Catch-all: any unknown or not-permitted path lands here. */}
  <Route>
    <NotAuthorized token={token} LogoutTimeout={LogoutTimeout}/>
  </Route>

</Switch>
<Footer token={token} setViewMenusState={setViewMenusState} viewMenusState={viewMenusState}/>
  </Router>
  <InstallAppPrompt />
</React.Fragment>

  );}

  else {return (<NotAuthorized LogoutTimeout={LogoutTimeout}/>)}}

export default App;